/**
 * iconManager.js — Enterprise SVG Icon System
 * Mikhmel Cornerstone4D DICOM Viewer Pro v6
 *
 * [USAGE]
 *   import { getIcon, injectIconSprite, ICONS } from './iconManager.js';
 *
 *   // HTML: <span>${getIcon('screenshot')}</span>
 *   // JS:  element.innerHTML = getIcon('save');
 *   // Toast: showToast(`${getIcon('success')} Сохранено`, 'success');
 *
 * [INSTALLATION]
 *   1. Положите этот файл в /src/core/iconManager.js
 *   2. В index.html добавьте: <div id="mikhmel-icon-sprite" style="display:none;"></div>
 *   3. В main.js: import { injectIconSprite } from './core/iconManager.js'; injectIconSprite();
 *   4. Используйте getIcon('name') в любом месте
 *
 * [COLORS]
 *   По умолчанию fill="currentColor" — иконка наследует цвет родительского элемента.
 *   Для явного цвета: getIcon('error', 16, '#ff4444')
 */

// ══════════════════════════════════════════════════════════════
//  SVG SPRITE (все иконки одним спрайтом)
// ══════════════════════════════════════════════════════════════

const SVG_SPRITE = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display:none;">

  <!-- ═══ НАВИГАЦИЯ / VIEWPORT ═══ -->
  <symbol id="icon-screenshot" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2z"/>
    <circle cx="12" cy="13" r="3" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="currentColor" d="M8 8h.01M16 8h.01"/>
  </symbol>

  <symbol id="icon-save" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/>
    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" points="17 21 17 13 7 13 7 21"/>
    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" points="7 3 7 8 15 8"/>
  </symbol>

  <symbol id="icon-folder-open" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2v11z"/>
  </symbol>

  <symbol id="icon-download" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/>
  </symbol>

  <symbol id="icon-upload" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/>
  </symbol>

  <symbol id="icon-export" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M12 3v12M8 7l4-4 4 4"/>
    <rect x="4" y="15" width="16" height="6" rx="1" fill="none" stroke="currentColor" stroke-width="2"/>
  </symbol>

  <symbol id="icon-import" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M12 21V9M8 17l4 4 4-4"/>
    <rect x="4" y="3" width="16" height="6" rx="1" fill="none" stroke="currentColor" stroke-width="2"/>
  </symbol>

  <symbol id="icon-copy" viewBox="0 0 24 24">
    <rect x="9" y="9" width="13" height="13" rx="2" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
  </symbol>

  <!-- ═══ ИНСТРУМЕНТЫ ═══ -->
  <symbol id="icon-zoom-in" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M21 21l-4.35-4.35M11 8v6M8 11h6"/>
  </symbol>

  <symbol id="icon-zoom-out" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M21 21l-4.35-4.35M8 11h6"/>
  </symbol>

  <symbol id="icon-reset" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M1 4v6h6M23 20v-6h-6"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15"/>
  </symbol>

  <symbol id="icon-magnifier" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M21 21l-4.35-4.35"/>
    <circle cx="11" cy="11" r="3" fill="none" stroke="currentColor" stroke-width="1.5" stroke-dasharray="1 1"/>
  </symbol>

  <symbol id="icon-ruler" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M4 10l6-6 10 10-6 6-10-10z"/>
    <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" d="M9 7l1 1M12 10l1 1M7 9l1 1M10 12l1 1"/>
  </symbol>

  <symbol id="icon-crosshair" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.5"/>
    <path fill="none" stroke="currentColor" stroke-width="1.5" d="M12 1v4M12 19v4M1 12h4M19 12h4"/>
    <circle cx="12" cy="12" r="2" fill="currentColor"/>
  </symbol>

  <symbol id="icon-bookmark" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2v16z"/>
  </symbol>

  <symbol id="icon-bookmark-filled" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2v16z"/>
  </symbol>

  <symbol id="icon-undo" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M3 7v6h6M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13"/>
  </symbol>

  <symbol id="icon-redo" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M21 7v6h-6M3 17a9 9 0 019-9 9 9 0 016 2.3L21 13"/>
  </symbol>

  <symbol id="icon-trash" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M10 11v6M14 11v6"/>
  </symbol>

  <symbol id="icon-settings" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
  </symbol>

  <symbol id="icon-edit" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </symbol>

  <!-- ═══ МЕДИА / CINE ═══ -->
  <symbol id="icon-play" viewBox="0 0 24 24">
    <polygon fill="currentColor" points="5 3 19 12 5 21 5 3"/>
  </symbol>

  <symbol id="icon-pause" viewBox="0 0 24 24">
    <rect x="4" y="4" width="6" height="16" rx="1" fill="currentColor"/>
    <rect x="14" y="4" width="6" height="16" rx="1" fill="currentColor"/>
  </symbol>

  <symbol id="icon-stop" viewBox="0 0 24 24">
    <rect x="4" y="4" width="16" height="16" rx="2" fill="currentColor"/>
  </symbol>

  <symbol id="icon-cine" viewBox="0 0 24 24">
    <rect x="2" y="6" width="20" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="1.5" d="M8 6v12M16 6v12M12 6v12"/>
    <polygon fill="currentColor" points="10 10 14 12 10 14"/>
  </symbol>

  <symbol id="icon-fullscreen" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"/>
  </symbol>

  <symbol id="icon-fullscreen-exit" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3"/>
  </symbol>

  <!-- ═══ ОРИЕНТАЦИЯ / 3D ═══ -->
  <symbol id="icon-3d" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"
      d="M12 2L3 7l9 5 9-5-9-5zM3 17l9 5 9-5M3 12l9 5 9-5"/>
  </symbol>

  <symbol id="icon-cube" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"
      d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
    <polyline fill="none" stroke="currentColor" stroke-width="1.5" points="3.27 6.96 12 12.01 20.73 6.96"/>
    <line fill="none" stroke="currentColor" stroke-width="1.5" x1="12" y1="22.08" x2="12" y2="12"/>
  </symbol>

  <symbol id="icon-axial" viewBox="0 0 24 24">
    <rect x="4" y="6" width="16" height="12" rx="1" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="1" d="M4 9h16M4 15h16"/>
    <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
    <text x="18" y="8" fill="currentColor" font-size="7" font-weight="bold" text-anchor="middle">A</text>
  </symbol>

  <symbol id="icon-sagittal" viewBox="0 0 24 24">
    <rect x="6" y="4" width="12" height="16" rx="1" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="1" d="M9 4v16M15 4v16"/>
    <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
    <text x="8" y="8" fill="currentColor" font-size="7" font-weight="bold" text-anchor="middle">S</text>
  </symbol>

  <symbol id="icon-coronal" viewBox="0 0 24 24">
    <rect x="4" y="4" width="16" height="16" rx="1" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="1" d="M4 8h16M4 16h16"/>
    <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
    <text x="19" y="8" fill="currentColor" font-size="7" font-weight="bold" text-anchor="middle">C</text>
  </symbol>

  <!-- ═══ АНАТОМИЯ ═══ -->
  <symbol id="icon-bone" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M6 6c-2 2-2 4 0 6s4 2 6 0 2-4 0-6-4-2-6 0zM18 18c2-2 2-4 0-6s-4-2-6 0-2 4 0 6 4 2 6 0z"/>
    <line fill="none" stroke="currentColor" stroke-width="1.5" x1="12" y1="12" x2="12" y2="12"/>
  </symbol>

  <symbol id="icon-skin" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"/>
    <path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
      d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/>
  </symbol>

  <symbol id="icon-muscle" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M6 12V6a3 3 0 016 0v3M12 9v3a3 3 0 006 0V6M18 12v6a3 3 0 01-6 0v-3M12 15V9"/>
  </symbol>

  <symbol id="icon-heart" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
  </symbol>

  <symbol id="icon-vascular" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      d="M3 12c3-4 6-8 9-8s6 4 9 8"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      d="M3 12c3 4 6 8 9 8s6-4 9-8"/>
    <circle cx="12" cy="12" r="2" fill="currentColor"/>
    <circle cx="7" cy="10" r="1" fill="currentColor"/>
    <circle cx="17" cy="14" r="1" fill="currentColor"/>
  </symbol>

  <symbol id="icon-lung" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M6 12V6a4 4 0 018 0v3M14 9v3a5 5 0 008 0V7M6 19c-1.5-1-3-3-3-6s1.5-5 3-6M18 19c1.5-1 3-3 3-6s-1.5-5-3-6"/>
  </symbol>

  <symbol id="icon-brain" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"
      d="M12 2C8 2 4 5 4 9c0 3 2 5 4 6v4a2 2 0 004 0M12 2c4 0 8 3 8 7 0 3-2 5-4 6v4a2 2 0 01-4 0"/>
    <path fill="none" stroke="currentColor" stroke-width="1" d="M8 13c-1-2-1-5 0-7M16 13c1-2 1-5 0-7"/>
  </symbol>

  <symbol id="icon-liver" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"
      d="M14 3h5a2 2 0 012 2v4M6 21H3a2 2 0 01-2-2v-4"/>
    <path fill="none" stroke="currentColor" stroke-width="2" d="M5 8a7 7 0 0114 6 7 7 0 01-14 6"/>
    <line fill="none" stroke="currentColor" stroke-width="1.5" x1="12" y1="8" x2="12" y2="18"/>
    <line fill="none" stroke="currentColor" stroke-width="1" x1="9" y1="10" x2="15" y2="10"/>
  </symbol>

  <symbol id="icon-kidney" viewBox="0 0 24 24">
    <ellipse cx="8" cy="12" rx="5" ry="7" fill="none" stroke="currentColor" stroke-width="2"/>
    <ellipse cx="16" cy="12" rx="5" ry="7" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="1.5" d="M8 7a2 2 0 012 2M16 7a2 2 0 00-2 2"/>
  </symbol>

  <symbol id="icon-spine" viewBox="0 0 24 24">
    <line fill="none" stroke="currentColor" stroke-width="2" x1="12" y1="3" x2="12" y2="21"/>
    <rect x="9" y="4" width="6" height="3" rx="1" fill="none" stroke="currentColor" stroke-width="1.5"/>
    <rect x="9" y="9" width="6" height="3" rx="1" fill="none" stroke="currentColor" stroke-width="1.5"/>
    <rect x="9" y="14" width="6" height="3" rx="1" fill="none" stroke="currentColor" stroke-width="1.5"/>
    <rect x="9" y="19" width="6" height="3" rx="1" fill="none" stroke="currentColor" stroke-width="1.5"/>
  </symbol>

  <symbol id="icon-baby" viewBox="0 0 24 24">
    <circle cx="12" cy="8" r="5" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      d="M5 20c2-4 12-4 14 0"/>
    <path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
      d="M7 6c-2 1-3 3-3 5M17 6c2 1 3 3 3 5"/>
  </symbol>

  <!-- ═══ СТАТУС / УВЕДОМЛЕНИЯ ═══ -->
  <symbol id="icon-success" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M8 12l2 2 4-4"/>
  </symbol>

  <symbol id="icon-error" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M15 9l-6 6M9 9l6 6"/>
  </symbol>

  <symbol id="icon-warning" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
    <line fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" x1="12" y1="9" x2="12" y2="13"/>
    <line fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" x1="12" y1="17" x2="12.01" y2="17"/>
  </symbol>

  <symbol id="icon-info" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
    <line fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" x1="12" y1="16" x2="12" y2="12"/>
    <line fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" x1="12" y1="8" x2="12.01" y2="8"/>
  </symbol>

  <symbol id="icon-loading" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
  </symbol>

  <!-- ═══ РАЗНОЕ ═══ -->
  <symbol id="icon-contrast" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="currentColor" d="M12 2a10 10 0 000 20V2z"/>
  </symbol>

  <symbol id="icon-invert" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="currentColor" d="M12 2a10 10 0 100 20V2z"/>
  </symbol>

  <symbol id="icon-palette" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" d="M12 2a10 10 0 00-3 19.4c.5-.4 1-.9 1-1.4 0-1.1-.9-2-2-2H7"/>
    <circle cx="8.5" cy="10" r="1.5" fill="currentColor"/>
    <circle cx="15.5" cy="8" r="1.5" fill="currentColor"/>
    <circle cx="16.5" cy="14" r="1.5" fill="currentColor"/>
  </symbol>

  <symbol id="icon-layers" viewBox="0 0 24 24">
    <polygon fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" points="12 2 2 7 12 12 22 7 12 2"/>
    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" points="2 17 12 22 22 17"/>
    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" points="2 12 12 17 22 12"/>
  </symbol>

  <symbol id="icon-clock" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" points="12 6 12 12 16 14"/>
  </symbol>

  <symbol id="icon-check" viewBox="0 0 24 24">
    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" points="20 6 9 17 4 12"/>
  </symbol>

  <symbol id="icon-plus" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M12 5v14M5 12h14"/>
  </symbol>

  <symbol id="icon-minus" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M5 12h14"/>
  </symbol>

  <symbol id="icon-close" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M18 6L6 18M6 6l12 12"/>
  </symbol>

  <symbol id="icon-search" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M21 21l-4.35-4.35"/>
  </symbol>

  <symbol id="icon-lock" viewBox="0 0 24 24">
    <rect x="3" y="11" width="18" height="11" rx="2" fill="none" stroke="currentColor" stroke-width="2"/>
    <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M7 11V7a5 5 0 0110 0v4"/>
  </symbol>

  <symbol id="icon-globe" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
    <ellipse cx="12" cy="12" rx="4" ry="10" fill="none" stroke="currentColor" stroke-width="1.5"/>
    <path fill="none" stroke="currentColor" stroke-width="1.5" d="M2 12h20"/>
  </symbol>
</svg>`;

// ══════════════════════════════════════════════════════════════
//  ICON NAMES DICTIONARY (для автодополнения)
// ══════════════════════════════════════════════════════════════

export const ICONS = Object.freeze({
  // Navigation
  SCREENSHOT: 'screenshot',
  SAVE: 'save',
  FOLDER_OPEN: 'folder-open',
  DOWNLOAD: 'download',
  UPLOAD: 'upload',
  EXPORT: 'export',
  IMPORT: 'import',
  COPY: 'copy',

  // Tools
  ZOOM_IN: 'zoom-in',
  ZOOM_OUT: 'zoom-out',
  RESET: 'reset',
  MAGNIFIER: 'magnifier',
  RULER: 'ruler',
  CROSSHAIR: 'crosshair',
  BOOKMARK: 'bookmark',
  BOOKMARK_FILLED: 'bookmark-filled',
  UNDO: 'undo',
  REDO: 'redo',
  TRASH: 'trash',
  SETTINGS: 'settings',
  EDIT: 'edit',

  // Media
  PLAY: 'play',
  PAUSE: 'pause',
  STOP: 'stop',
  CINE: 'cine',
  FULLSCREEN: 'fullscreen',
  FULLSCREEN_EXIT: 'fullscreen-exit',

  // Orientation
  VIEW_3D: '3d',
  CUBE: 'cube',
  AXIAL: 'axial',
  SAGITTAL: 'sagittal',
  CORONAL: 'coronal',

  // Anatomy
  BONE: 'bone',
  SKIN: 'skin',
  MUSCLE: 'muscle',
  HEART: 'heart',
  VASCULAR: 'vascular',
  LUNG: 'lung',
  BRAIN: 'brain',
  LIVER: 'liver',
  KIDNEY: 'kidney',
  SPINE: 'spine',
  BABY: 'baby',

  // Status
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  LOADING: 'loading',

  // Misc
  CONTRAST: 'contrast',
  INVERT: 'invert',
  PALETTE: 'palette',
  LAYERS: 'layers',
  CLOCK: 'clock',
  CHECK: 'check',
  PLUS: 'plus',
  MINUS: 'minus',
  CLOSE: 'close',
  SEARCH: 'search',
  LOCK: 'lock',
  GLOBE: 'globe',
});

// ══════════════════════════════════════════════════════════════
//  PUBLIC API
// ══════════════════════════════════════════════════════════════

/**
 * Внедрить SVG-спрайт в DOM. Вызвать один раз в main.js.
 * @param {string} [containerId='mikhmel-icon-sprite'] — ID контейнера
 */
export function injectIconSprite(containerId = 'mikhmel-icon-sprite') {
  // Проверяем, не внедрён ли уже
  if (document.getElementById(containerId)) return;

  const container = document.createElement('div');
  container.id = containerId;
  container.style.display = 'none';
  container.innerHTML = SVG_SPRITE;
  document.body.appendChild(container);
}

/**
 * Получить SVG-иконку по имени.
 * @param {string} name — имя иконки из ICONS (напр. 'screenshot', 'save')
 * @param {number} [size=16] — размер в пикселях
 * @param {string} [color='currentColor'] — цвет (currentColor наследует от родителя)
 * @param {string} [className=''] — дополнительные CSS-классы
 * @returns {string} HTML-строка с SVG
 *
 * @example
 * // В HTML:
 * button.innerHTML = getIcon('play') + ' Запустить';
 *
 * // В тосте:
 * showToast(`${getIcon('success', 14, '#4f8')} Сохранено`, 'success');
 *
 * // С классом:
 * element.innerHTML = getIcon('settings', 20, '#fff', 'spin-animation');
 */
export function getIcon(name, size = 16, color = 'currentColor', className = '') {
  const classAttr = className ? ` class="${className}"` : '';
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="${color}"${classAttr} aria-hidden="true">
    <use href="#icon-${name}"/>
  </svg>`;
}

/**
 * Создать DOM-элемент SVG (для программного использования).
 * @param {string} name
 * @param {number} [size=16]
 * @param {string} [color='currentColor']
 * @returns {SVGSVGElement}
 */
export function createIconElement(name, size = 16, color = 'currentColor') {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', color);
  svg.setAttribute('aria-hidden', 'true');

  const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
  use.setAttribute('href', `#icon-${name}`);
  svg.appendChild(use);

  return svg;
}

export default { getIcon, createIconElement, injectIconSprite, ICONS };